var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.836,
    height: 18,
    viewBox: "0 0 20.836 18",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6165",
    "data-name": "Group 6165",
    transform: "translate(-1951 -358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6863",
    "data-name": "Path 6863",
    d: "M13.079,21.919l-.963-.963a3.356,3.356,0,0,1,.022-4.771l.941-.918a10.461,10.461,0,0,0-1.12-.067C8.969,15.2,3,16.7,3,19.679v2.24H13.079Zm-1.12-8.959A4.48,4.48,0,1,0,7.48,8.48a4.478,4.478,0,0,0,4.48,4.48",
    transform: "translate(1948 354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6864",
    "data-name": "Path 6864",
    d: "M16.633,20.6a1.129,1.129,0,0,1-1.59,0l-2.318-2.341a1.109,1.109,0,0,1,0-1.557l.011-.011a1.1,1.1,0,0,1,1.568,0l1.534,1.534L20.8,13.235a1.115,1.115,0,0,1,1.579,0l.011.011a1.109,1.109,0,0,1,0,1.557l-5.756,5.8Z",
    transform: "translate(1949.128 355.068)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrIcon);
export default __webpack_public_path__ + "static/media/hr_icon.1c7d39fc075fb0df6c86b486c15fe1bf.svg";
export { ForwardRef as ReactComponent };